import auth from '@/f1/service/auth';
import Custom from '@/f1/service/custom';
import config from '@/f1/config';
import Language from './language';
// import i18n from '@/f1/service/i18n';
import '../login.css';

const _i18n_data = {
  change_password: {
    EN : `now the password change cycle reached, now change it ?`,
    KO : `비밀번호 변경 주기에 도달했습니다. 변경하시겠습니까?`,
  },
  loggedin: {
    EN : `Try to login`,
    KO : `로그인 요청!`,
  },
  username: {
    EN : `Username required.`,
    KO : `아이디를 입력하세요.`,
  },
  password: {
    EN : `Password required.`,
    KO : `비밀번호를 입력하세요.`,
  }
};

export default {
  components: { Language },
  computed: { i18n_data() { return _i18n_data; } }, // i18n 메세지 변환용.
  data: () => ({ auth, custom : Custom.custom_default, check_preflight : false, require_otp : false,remember_username: false, is_require_change_password : false,  m: { username: '', password: '', otp: '' }, lock: false, }),
  methods: {
    reset() {
      console.log("reset")
      this.$router.push({ name: 'auth_reset' });
    },
    async preflight() {
      // return true or false
      return await auth.preflight(this.m.username, this.m.password);
    },
    // regist() { this.$router.push({ name: 'auth_register'}); },
    async login() {
      if(_.isEmpty(this.m.username)) { return this.$toastr.e(this.i18n_data['username'][this.i18n] || 'Username required.'); }
      if(_.isEmpty(this.m.password)) { return this.$toastr.e(this.i18n_data['password'][this.i18n] || 'Password required!'); }
      if(this.lock) { return this.$toastr.i('Please wait, I\'m trying to login.'); }
      // try {
      //   if(!this.check_preflight) {
      //     this.require_otp = await this.preflight();
      //     this.check_preflight = true;
      //   }
      //   if(this.require_otp && !this.m.otp) { return this.$toastr.i('please input OTP', 'require') }
      // } catch (e) {  return typeof e.data == typeof '' ? this.$toastr.e(e.data) : this.$toastr.w(e.data ? e.data.message : e.statusText); }
      this.lock = true;
      try {
        let rs = await auth.login(this.m.username, this.m.password, this.m.otp);
        if(rs){
          let ts = new Date().getTime();
          this.is_require_change_password = await auth.checkPasswordCycle({ts : ts});
          this.$route.query.redirect = this.is_require_change_password && confirm(this.i18n_data['change_password'][this.i18n || 'EN']) ?
            "/profile/edit" : (auth.profile.permissions.indexOf('billing') > -1 ? '/billing' : this.$route.query.redirect)


          if(this.auth.license && this.auth.license.WMDS && this.auth.license.WMDS.use == true && !(this.auth.license.WSFinder.use && this.auth.license.WEBCastle.use)) { this.$route.query.redirect = '/wmds/dashboard' }
          if(this.auth.license && this.auth.license.WSFinder && this.auth.license.WSFinder.use == true && !(this.auth.license.WMDS.use && this.auth.license.WEBCastle.use)) { this.$route.query.redirect = '/wsfinder/dashboard' }
          if(this.auth.license && this.auth.license.WEBCastle && this.auth.license.WEBCastle.use == true && !(this.auth.license.WMDS.use && this.auth.license.WSFinder.use)) { this.$route.query.redirect = '/webcastle/dashboard' }

        }
        // this.i18n_data['loggedin'][this.i18n]
        console.log(this.i18n_data['loggedin'], this.i18n)


        this.$toastr.i(this.i18n_data['loggedin'][this.i18n || 'EN']);
        // 아이디 저장여부
        if(this.remember_username) { window.localStorage.setItem('username', this.m.username); } else { window.localStorage.removeItem('username'); }
        this.$router.replace(this.$route.query.redirect || '/'); // 대시보드 경로로 변경 필요함
      } catch(e) { console.info(e); this.$toastr.e(e.data && (e.data.message || e.data) || 'unexpected error.'); console.log(e); }
      this.lock = false;
    }
  },
  created() { console.log('[vue] login', 'created'); },
  destroyed() { console.log('[vue] login', 'destroyed'); },
  mounted() {
    this.custom = Custom.setting()
    console.log('[vue] login', 'mounted', this.custom.slogan);
    if(auth.isAuthenticated()) { this.$router.replace('/');  } // 대시보드 경로로 변경 필요함
    if(window.localStorage.getItem('username')) { this.remember_username = true; this.m.username = window.localStorage.getItem('username'); }
    this.custom.version = config.version
  }
}
